/**
 * Helper function to convert from rem to pixels.
 * Supports SSR and is aware of user-defined custom font sizes.
 *
 * @param rem number in rems
 * @returns same number converted to pixels
 * @example `1rem = 16px (can vary depending on user settings)`
 */
export function convertRemToPx(rem: number) {
  if (typeof document === 'undefined') return rem * 16;
  return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
}
